import transactionActionTypes from './transactions.types';

const INITIAL_STATE = {
    transactions: [],
    isFetching: false,
    error: undefined
};

const transactionsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case transactionActionTypes.FETCH_TRANSACTIONS_START:
            return {
                ...state,
                isFetching: true
            };
        case transactionActionTypes.FETCH_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                transactions: action.payload
            };
        case transactionActionTypes.FETCH_TRANSACTIONS_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default transactionsReducer;
